<template>
    <div>
        <b-modal id="worker_activity_modal" size="lg" ref="worker_activity_modal" hide-footer>
            <div slot="modal-header" class="mh">
                <div id="mh-text">
                    <h2><i class="fas fa-clock"></i> GEOTEC WORKER ACTIVITY</h2>
                    <p id="mh-info">{{ this.workerName }}</p>
                </div>
                <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
            </div>
            <div class="row">
                <div class="col-12">
                    <p v-if="loading">Loading worker data, please wait ...</p>
                    <table v-else class="table">
                        <thead>
                            <tr>
                                <th>Clock In</th>
                                <th>Clock Out</th>
                                <th>Duration (hours)</th>    
                            </tr>
                        </thead>
                        <tbody class="mt-2">
                            <tr v-for="log in data">
                                <td>{{ log.clockIn }}</td>
                                <td v-html="log.clockOut ?? '<span class=\'text-success\'><strong>ACTIVE</strong></span>'"></td>
                                <td>{{ log.duration }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td></td>
                                <td><strong>Total hours on site</strong></td>
                                <td><strong>{{ totalHoursOnSite() }}</strong></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
export default {
    name: "clock_in_out_worker_activity",
    components: {
        loadingCube
    },
    data() {
        return {
            data: {},
            loading: true,
            workerId: null,
            orderJobId: null,
            workerName: null
        };
    },
    mounted() {
        this.$root.$on("bv::show::modal", (payload) => {
            this.workerId = payload.data.workerId;
            this.orderJobId = payload.data.orderJobId;
            this.workerName = payload.data.workerName;
            this.getData();
            this.showModal();
        });
    },
    methods: {
        hideModal() {
            this.$refs.worker_activity_modal.hide();
        },
        showModal() {
            this.$refs.worker_activity_modal.show();
        },
        getData() {
            this.loading = true;
            axios.get(this.crmApiPath + 'geo_tracking/get_worker_activity/' + this.orderJobId + '/' + this.workerId).then(workers => {
                this.data = workers.data;
                this.loading = false;
            });
        },
        totalHoursOnSite() {
            if(!this.data.length) {
                return 0.00;
            }

            let total = 0.00;
            this.data.forEach(function(el) {
                total += parseFloat(el.duration);
            });

            return total.toFixed(2);
        }
    },
};
</script>